import React from 'react';
import Pic1 from '../../InstallImages/Modules/AX320';


const moduleLink = <a href="https://www.dropbox.com/s/9ikgr5mhd6ikutw/DB_120zlg_blackpremium_HC_MiA_EN_1000V_neo.pdf?dl=0" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const Module = () => (
    <div>
        <div className="col span-1-of-2">

            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">
                Axitec 120 halfcell monocrystalline high performance solar module.
            </p>
            <ul> <h1>Key Features</h1>
                <li className="specsText">All Black</li>
                <li className="specsText">15 years manufacturer‘s guarantee on 90 % of the nominal performance</li>
                <li className="specsText">25 years manufacturer‘s guarantee on 85 % of the nominal performance</li>
                <li className="specsText">Highest module performance through Half-Cut-technology and tested materials</li>
                <li className="specsText">High stability due to AXITEC-Soft-Grip-Seam aluminium frame construction</li>
                <li className="specsText">Maximum 5400 Pa snow load</li>
                <li className="specsText">{moduleLink}</li>
            </ul>
        </div>
    </div>
);


export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/ax320.js